export const scrollToPromoCodeInput = (
  ref: React.RefObject<HTMLElement>,
  offset = 0,
  behavior: ScrollBehavior = 'auto'
) => {
  if (!ref.current) return;

  const top = window.scrollY + ref.current.getBoundingClientRect().top - offset;

  window.scrollTo({ top, behavior });
};
